var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGradientImageIcon = function SvgGradientImageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.686 33.26v55.508c0 2.38-1.586 3.965-3.965 3.965h-5.947L59.641 62.6c-1.586-1.585-3.965-1.585-5.55 0L35.16 80.862H20.39V33.26c0-2.38 1.585-3.965 3.964-3.965h71.367c2.38 0 3.965 1.586 3.965 3.965Zm-57.49 7.93c-3.172 0-5.947 2.776-5.947 5.948 0 3.172 2.775 5.947 5.947 5.947s5.947-2.776 5.947-5.947c0-3.172-2.775-5.948-5.947-5.948Z",
    fill: "url(#gradient_image_icon_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.188 53.085c-1.586-1.586-3.965-1.586-5.55 0L54.883 80.839H20.389v7.93c0 2.378 1.587 3.964 3.965 3.964h71.367c2.38 0 3.965-1.586 3.965-3.965V64.584L88.188 53.085Z",
    fill: "url(#gradient_image_icon_svg__b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_image_icon_svg__a",
    x1: 60.038,
    y1: 29.296,
    x2: 60.038,
    y2: 92.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_image_icon_svg__b",
    x1: 86.682,
    y1: 55.441,
    x2: 19.529,
    y2: 98.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.271
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
};

export default SvgGradientImageIcon;